import {isEmpty} from 'lodash';
import {EMAIL_LOCAL_STORAGE_KEY, BILLING_ERROR_LOCAL_STORAGE_KEY} from '../utils/constants';

const DEEP_LINK_PARAM_TYPE = {
    pmscParams: 'pmsc_qc_deep_link_params',
    ulxParams: 'ulx_qc_deep_link_params'
};

const saveUserDetails = (accountDetails) => {
    const userDetails = {
        companyName: accountDetails.companyName,
        contact: {
            phone: {
                countryCode: accountDetails.countryCode,
                number: accountDetails.phoneNumber
            }
        },
        companyLocation: accountDetails.companyLocation,
        propertyCount: accountDetails.propertyCount,
        companyRegistration: accountDetails.companyRegistration || null,
        billingCurrency: accountDetails.currency,
    };
    localStorage.setItem('ipmobUserDetail', JSON.stringify(userDetails));
};

const getSavedUserDetails = () => localStorage.getItem('ipmobUserDetail');

const removeSavedUserDetails = () => localStorage.removeItem('ipmobUserDetail');

const getInitialComponentState = (publicUuid) => (typeof localStorage === 'undefined') ? null : localStorage.getItem(`${publicUuid}.state`);

const setComponentState = (publicUuid, name, state) => {
    const loadingDateTime = new Date();
    const componentState = {
        name,
        loadingDateTime,
        state
    };

    const componentsStateInfo = (getInitialComponentState(publicUuid)) ? JSON.parse(getInitialComponentState(publicUuid)) : [];
    let stateExist = false;
    for (const component of componentsStateInfo) {
        if (component.name === name) {
            stateExist = true;
            component.loadingDateTime = loadingDateTime;
            component.state = state;
            break;
        }
    }

    if (!stateExist) {
        componentsStateInfo.push(componentState);
    }

    localStorage.setItem(`${publicUuid}.state`, JSON.stringify(componentsStateInfo));
};

const getComponentState = (publicUuid, name) => {
    let storedComponentInfo;

    if (typeof localStorage === 'undefined') {
        return null;
    }

    storedComponentInfo = localStorage.getItem(`${publicUuid}.state`);
    const parsedComponentInfo = !isEmpty(storedComponentInfo) ? JSON.parse(storedComponentInfo) : [];
    const componentState = (parsedComponentInfo.length > 0) ? parsedComponentInfo.find((element) => element.name === name) : null;

    return componentState;
};

const deleteComponentState = (publicUuid) => {
    if (typeof localStorage !== 'undefined') {
        localStorage.removeItem(`${publicUuid}.state`);
    }
};

const setComponentPath = (publicUuid, path) => localStorage.setItem(`${publicUuid}.path`, path);

const getComponentPath = (publicUuid) => (typeof localStorage === 'undefined') ? null : localStorage.getItem(`${publicUuid}.path`);

const setDeepLinkParams = (paramType, deepLinkParams) => localStorage.setItem(paramType, JSON.stringify(deepLinkParams));

const getDeepLinkParams = (paramType) => JSON.parse(localStorage.getItem(paramType));

const removeDeepLinkParams = (paramType) => localStorage.removeItem(paramType);

const getEmailLocalStorage = () => {
    const currentStorage = localStorage.getItem(EMAIL_LOCAL_STORAGE_KEY);
    return (currentStorage) ? JSON.parse(currentStorage) : {};
}

function setEmailStorageExpiry(helpFormData) {
    const storage = getEmailLocalStorage();
    const INELIGIBLE_SUBTYPE = helpFormData.data.message;

    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 1); // TTL is 24 hours
    localStorage.setItem(EMAIL_LOCAL_STORAGE_KEY, JSON.stringify({
        ...storage,
        [INELIGIBLE_SUBTYPE]: expiryDate
    }));
}

const savePreferredLocale = (publicUuid, locale) => locale && typeof localStorage !== 'undefined' ? localStorage.setItem(`${publicUuid}.preferredLocale`, locale) : null;

const getPreferredLocale = (publicUuid) => (typeof localStorage === 'undefined') ? null : localStorage.getItem(`${publicUuid}.preferredLocale`);

const getBillingSubmitErrorAttempt = () => (typeof localStorage !== 'undefined') ? localStorage.getItem(BILLING_ERROR_LOCAL_STORAGE_KEY) : null;

const saveBillingSubmitErrorAttempt = () => {
    const currentStorage = getBillingSubmitErrorAttempt();
    const noOfAttempts = (currentStorage) ? (parseInt(currentStorage, 10) + 1) : 1;
    localStorage.setItem(BILLING_ERROR_LOCAL_STORAGE_KEY, noOfAttempts);
};

export {
    getEmailLocalStorage,
    setEmailStorageExpiry,
    saveUserDetails,
    getSavedUserDetails,
    removeSavedUserDetails,
    setComponentState,
    getComponentState,
    deleteComponentState,
    setComponentPath,
    getComponentPath,
    setDeepLinkParams,
    getDeepLinkParams,
    removeDeepLinkParams,
    DEEP_LINK_PARAM_TYPE,
    savePreferredLocale,
    getPreferredLocale,
    getBillingSubmitErrorAttempt,
    saveBillingSubmitErrorAttempt
};
